import { render, staticRenderFns } from "./DeemedReport.vue?vue&type=template&id=2a096bc4&scoped=true"
import script from "./DeemedReport.vue?vue&type=script&lang=js"
export * from "./DeemedReport.vue?vue&type=script&lang=js"
import style0 from "./DeemedReport.vue?vue&type=style&index=0&id=2a096bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a096bc4",
  null
  
)

export default component.exports